// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__13Loc","label":"CategoryService_label__8Dtfz","location":"CategoryService_location__CvlUd"};